import { default as vl } from "../../vg/vega-lite.js";
import { default as vega } from "../../vg/vega.js";
import { util } from "./util.js";
import { extractVgData } from "./vega_data_extract.js";
import { renderVirtual } from "../virtual.js";


export async function makeVega(sel, fronto) {
  let rendered = await renderVirtual(sel, fronto);
  let compiledFronto = rendered.compiled;
  let spec = vl.compile(compiledFronto.vlView, {}).spec;
  let view = new vega.View(vega.parse(spec), { renderer: 'svg' });
  let vl_spec = compiledFronto.vlView;
  let compiled = await view.runAsync();
  let size = [compiled.signal('width'), compiled.signal('height')];
  let state = compiled._runtime;
  let origin_state = state.data; // for those without "facets"
  let subcontext = state.subcontext; // for those with "facets"
  let replacements = document.querySelectorAll("#virtual-" + sel + " replacement");
  replacements = getBBox(replacements);
  let annotations = document.querySelectorAll("#virtual-" + sel + ' annotation[data-role="internalAnnotation"]');
  annotations = getBBox(annotations);
  let legends = document.querySelectorAll("#virtual-" + sel + ' div[data-role="legend-replacement"]');
  legends = getBBox(legends);
  let internal_texts = { replacements, annotations, legends };
  let mark_layers = Object.keys(origin_state).filter(function (el) {
    return util.isMarkLayer(el) || util.isPathGroupLayer(el);
  });
  let chart_size = [compiled._viewWidth, compiled._viewHeight];
  await view.toSVG();
  if (mark_layers.length > 0 || Object.keys(origin_state).includes("marks")) { // with layers
    return await extractVgData(origin_state, spec, vl_spec, "layers", null, size, chart_size, fronto, compiledFronto, internal_texts);
  } else if (subcontext) { // with facets
    let valid_subcontext = subcontext.filter(function (el) {
      return util.subcontextKeyTest(Object.keys(el.data));
    }) // to store the processed marks as below
    // obtaining mark info from subcontext data (only for facets)
    let width, height;
    try {
      width = compiled.signal(fronto.name.replace(/\-/gi, "_") + "_child_width");
    } catch {
      try {
        width = compiled.signal("width");
      } catch {
        width = size[0];
      }
    }
    try {
      height = compiled.signal(fronto.name.replace(/\-/gi, "_") + "_child_height");
    } catch {
      try {
        height = compiled.signal("height");
      } catch {
        height = size[1];
      }
    }
    size = [width, height];
    return await extractVgData(valid_subcontext, spec, vl_spec, "facets", origin_state, size, chart_size, fronto, compiledFronto, internal_texts);
  }
}

function getBBox(elems) {
  return Array.from(elems).map(d => {
    let t = d.getBoundingClientRect(), p = d.parentNode.getBoundingClientRect(); return {
      x: t.x - p.x,
      y: t.y - p.y,
      width: t.width,
      height: t.height
    }
  }
  )
}